import React, { useContext } from "react";

import { CreatableSelect } from "@atlaskit/select";
import LinkIcon from "@atlaskit/icon/glyph/editor/link";
import Textfield from "@atlaskit/textfield";
import xss from "xss";

import { useTheme } from "styled-components";
import { TextFieldContainer, SelectContainer } from "./Unsplash";
import { BackgroundDialogContext } from "../Context";
import { IMAGE_TYPES } from "../ImageSourceTypes";
import NoResults from "../NoResults";

function Link() {
  const { image, setImage, isMulti } = useContext(BackgroundDialogContext);

  const theme = useTheme();

  return (
    <>
      {isMulti ? (
        <SelectContainer>
          <CreatableSelect
            isMulti
            onChange={(links) => {
              setImage([
                ...image.filter((img) => img.source !== IMAGE_TYPES.LINK),
                ...links.map(({ value }) => ({
                  source: IMAGE_TYPES.LINK,
                  link: value,
                  id: "",
                })),
              ]);
            }}
            onCreateOption={(link) => {
              setImage([
                ...image,
                {
                  source: IMAGE_TYPES.LINK,
                  id: "",
                  link,
                },
              ]);
            }}
            value={image
              .filter((img) => img.source === IMAGE_TYPES.LINK)
              .map(({ link }) => ({ value: link, label: link }))}
          />
        </SelectContainer>
      ) : (
        <TextFieldContainer>
          <Textfield
            value={image.source === IMAGE_TYPES.LINK ? image?.link : ""}
            onChange={(e) =>
              setImage({
                source: IMAGE_TYPES.LINK,
                link: xss(e.target.value.replace('"', "")),
                id: "",
              })
            }
            elemBeforeInput={
              <LinkIcon size="large" primaryColor={theme.global.text.dark} />
            }
            placeholder="Insert image link"
          />
        </TextFieldContainer>
      )}

      <NoResults
        label="Link an image"
        content="Add a link to see the preview"
      />
    </>
  );
}

export default Link;
